export const formatInt = number => {
	return number?.toLocaleString() || '';
};
